import React from 'react';
import styled from 'styled-components';
import { FlexSpace } from './shared/FlexSpace';

const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 60px;
`;

const Title = styled.div`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const Value = styled.div`
  font-size: 1.25rem;
  color: #ffffff;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.2);
`;

const StatsBox = ({ title, value }: any) => {
  return (
    <Box>
      <Title>{title}</Title>
      <Value>{value || '--'}</Value>
    </Box>
  );
};


export default StatsBox;
